import { Typography, TextField, Button, Grid, Box } from '@mui/material';
import { createContext, useContext } from "react";
import { ContextSession } from '../../services/ContextSession';
import imagen from '../RNP/2541182.png'
import imagen2 from '../../img/7466140.png'
import './fichadni.component.css';

// Función para transformar los valores de parentesco
const formatParentesco = (parentesco) => {
    return parentesco
        .toLowerCase()
        .replace('_', ' ')
        .replace(/\b\w/g, char => char.toUpperCase());
};

export default function FichaArbol({ arbolData }) {
    const { sessionData } = useContext(ContextSession);

    // Verificar si arbolData es un array
    if (!Array.isArray(arbolData)) {
        return (
            <div className="ficha">
                <div className="datos-container">
                    <div className="datos">
                        <div className="seccion">
                            <h2>Sin Datos</h2>
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="valor1" align='center'>No se encontraron datos para esta persona</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Filtrar la persona principal
    const principal = arbolData.find(data => data.parentesco === "PRINCIPAL");

    // Filtrar Hijos
    const hijo = arbolData.filter(data => data.parentesco === "HIJO_A");

    // Filtrar Abuelos
    const abuelos = arbolData.filter(data =>
        data.parentesco === "ABUELO_PATERNO" ||
        data.parentesco === "ABUELA_PATERNA" ||
        data.parentesco === "ABUELO_MATERNO" ||
        data.parentesco === "ABUELA_MATERNA"
    );

    // Filtrar Padres
    const padres = arbolData.filter(data => data.parentesco === "PADRE" || data.parentesco === "MADRE");

    // Filtrar los familiares
    const familiares = arbolData.filter(data => data.parentesco !== "PRINCIPAL" &&
        data.parentesco !== "PADRE" && data.parentesco !== "MADRE" && data.parentesco !== "ABUELO_PATERNO" &&
        data.parentesco !== "ABUELA_PATERNA" && data.parentesco !== "ABUELO_MATERNO" && data.parentesco !== "ABUELA_MATERNA" && data.parentesco !== "HIJO_A"
    );

    return (
        <>
            <div className="ficha">
                <div className="datos-container">
                    <div className="datos">
                        <div className="seccion">
                            <h2>Árbol Genealógico</h2>
                            <table>
                                <tbody>
                                    {principal && (
                                        <div key={principal.id}>
                                            <tr>
                                                <td className="etiqueta">Nombres:</td>
                                                <td className="valor">{principal.nombrecompleto}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta1">Número De Identidad:</td>
                                                <td className="valor1">{principal.numeroidentidad}</td>
                                            </tr>
                                        </div>
                                    )}
                                    <h2>ABUELOS:</h2>
                                    {abuelos.map((data) => (
                                        <div key={data.id}>
                                            <tr>
                                                <td className="etiqueta">Nombres:</td>
                                                <td className="valor">{data.nombrecompleto}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta1">Número De Identidad:</td>
                                                <td className="valor1">{data.numeroidentidad}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta">Parentesco:</td>
                                                <td className="valor">{formatParentesco(data.parentesco)}</td>
                                            </tr>
                                            <tr>
                                                <td colSpan="2"><hr /></td>
                                            </tr>
                                        </div>
                                    ))}
                                    <h2>PADRES:</h2>
                                    {padres.map((data) => (
                                        <div key={data.id}>
                                            <tr>
                                                <td className="etiqueta">Nombres:</td>
                                                <td className="valor">{data.nombrecompleto}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta1">Número De Identidad:</td>
                                                <td className="valor1">{data.numeroidentidad}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta">Parentesco:</td>
                                                <td className="valor">{data.parentesco}</td>
                                            </tr>
                                            <tr>
                                                <td colSpan="2"><hr /></td>
                                            </tr>
                                        </div>
                                    ))}
                                    <h2>HIJOS:</h2>
                                    {hijo.length > 0 ? (
                                        hijo.map((data) => (
                                            <div key={data.id}>
                                                <tr>
                                                    <td className="etiqueta">Nombres:</td>
                                                    <td className="valor">{data.nombrecompleto}</td>
                                                </tr>
                                                <tr>
                                                    <td className="etiqueta1">Número De Identidad:</td>
                                                    <td className="valor1">{data.numeroidentidad}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="2"><hr /></td>
                                                </tr>
                                            </div>
                                        ))
                                    ) : (
                                        <tr>
                                            <td className="valor1" align='center'>No se encontraron datos de hijos</td>
                                        </tr>
                                    )}
                                    <h2>OTROS FAMILIARES:</h2>
                                    {familiares.length > 0 ? (
                                        familiares.map((data) => (
                                            <div key={data.id}>
                                                <tr>
                                                    <td className="etiqueta">Nombres:</td>
                                                    <td className="valor">{data.nombrecompleto}</td>
                                                </tr>
                                                <tr>
                                                    <td className="etiqueta1">Parentesco:</td>
                                                    <td className="valor1">{formatParentesco(data.parentesco)}</td>
                                                </tr>
                                                <tr>
                                                    <td className="etiqueta">Número De Identidad:</td>
                                                    <td className="valor">{data.numeroidentidad}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="2"><hr /></td>
                                                </tr>
                                            </div>
                                        ))
                                    ) : (
                                        <tr>
                                            <td className="valor1" align='center'>No se encontraron datos de otros familiares</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            {arbolData.error !== undefined && (
                <div className="ficha">
                    <div className="datos-container">
                        <div className="datos">
                            <div className="seccion">
                                <h2>Sin Datos</h2>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className="valor1" align='center'>No se encontraron datos para esta persona</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

